import {map, share} from 'rxjs/operators';
import {of, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class TerminalsService {
  path: string = '/api';
  terminals: any = null;
  partnerId: number | null = null;
  constructor(private apiService: ApiService) {}

  private observable: Observable<any> | null = null;

  getTerminals(partnerId: number) {
    if (partnerId === this.partnerId && this.terminals) {
      return of(this.terminals);
    } else if (this.observable) {
      return this.observable;
    } else {
      this.observable = this.apiService.get(`${this.path}/partners/${partnerId}/terminals`).pipe(
        map((response: any) => {
          this.observable = null;
          this.partnerId = partnerId;
          this.terminals = response;
          return this.terminals;
        }),
        share(),
      );
      return this.observable;
    }
  }
}
